module.exports = "/dist/assets/images/checkmark.svg";